import React from 'react';
import "./footer.css"
import FacebookIcon from "../../../assets/img/Footer/SocialIconFacebook.png";
import LinkdinIcon from "../../../assets/img/Footer/SocialIconLinkedin.png";
import YoutubeIcon from "../../../assets/img/Footer/SocialIconYoutube.png";
import InstagramIcon from "../../../assets/img/Footer/SocilaIconInstagram.png";
import footerIcon from "../../../assets/img/footerIcon.png";
import world from "../../../assets/img/world.png";
import {Link} from "react-router-dom";

function FooterView(props) {
    const {isMobileView, isXSView} = props;
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth', // This makes the scroll smooth
        });
    };

    return (
        <footer className="footer-container scroll-to-top" role="contentinfo">
            <div className="footer-x-padding">
                <div className="footer-grid">

                    {/* Brand & Contact */}
                    <div className="footercard">
                        <p className="fot_bold">CONTACT US</p>
                        <hr className="footer-divider pb-2"/>
                        <div className="footer-contact-item ">
                            <i className="fa fa-envelope "
                               style={{marginRight: '10px', color: "#FFFFFF"}}
                               aria-hidden="true"/>
                            <a href="mailto:info@simplicityinvesting.com"
                               style={{marginTop: "-8px"}}
                               className="footer-text"
                               target="_blank">info@simplicityinvesting.com
                            </a>
                        </div>
                        <div className="footer-contact-item">
                            <i className="fa fa-phone"
                               style={{marginRight: '10px', color: "#FFFFFF"}}
                               aria-hidden="true"/>
                            <a href="tel:+91 8408859836"
                               className="footer-text">+91 9112000725 </a>
                        </div>
                        <div className="footer-contact-item">
                            {/*<i className="fa-solid fa-location-dot"*/}
                            {/*   style={{marginRight: '10px', color: "#FFFFFF"}}*/}
                            {/*   aria-hidden="true"/>*/}
                            <img src={world}
                                 height={18}
                                 className=""/>
                            <a
                                href="https://www.simplicityinvesting.com"
                                rel="noopener noreferrer"
                                className="footer-text"
                            >
                                www.simplicityinvesting.com
                            </a>
                        </div>
                        <div className="footer-socials" style={{marginBottom: isMobileView ? '100px' : ''}}>
                            <ul className="list-inline social_icon  d-flex" style={{gap: 8}}>
                                <li>
                                    <a href="https://www.facebook.com/simplicityinvesting/"
                                       target="_blank">
                                        <img src={FacebookIcon}
                                             height={34}
                                             width={34}/>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/simplicity_investing/?hl=en"
                                       target="_blank">
                                        <img src={InstagramIcon}
                                             height={34}
                                             width={34}/>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/company/simplicity-investing-advisors-india-private-limited"
                                       target="_blank">
                                        <img src={LinkdinIcon}
                                             height={34}
                                             width={34}/>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.youtube.com/channel/UCgZWJrYWrt-HzKpcOpy9-CA"
                                       target="_blank">
                                        <img src={YoutubeIcon}
                                             height={34}
                                             width={34}/>
                                    </a>
                                </li>
                            </ul>
                        </div>
                            <iframe
                                id="Iframe1"
                                src="https://dunsregistered.dnb.com/SealAuthentication.aspx?Cid=1"
                                width="114px"
                                height="97px"
                                frameBorder="0"
                                scrolling="no"
                                allowTransparency={true}
                                title="D&B Registered"
                            />
                    </div>
                    {isXSView &&  <hr className="footer-mobile-divider"/>}

                    {/* REGULATORY DISCLOSURES */}
                    <div className="footercard">
                        <p className="fot_bold">REGULATORY DISCLOSURES</p>
                        <hr className="footer-divider"/>
                        <div className="footer-logo-wrap">
                            <div className="footer-brand-name">Simplicity Investing India Pvt. Ltd.</div>
                        </div>
                        <p className="footer-col-label pb-2 mt-0">SINCE JUNE 2011</p>
                        <hr className="footer-divider"/>
                        <p className="footer-col-label">AMFI REGISTRATION NUMBER</p>
                        <div className="footer-arn-badge">ARN-87401</div>
                        <p className="footer-col-label" style={{marginTop: 14}}>AMFI AUTHORIZED DISTRIBUTOR FOR</p>
                        <ul className="footer-bullet-list">
                            <li className="footer-text">Mutual Funds</li>
                            <li className="footer-text">Specialized Investment Funds (SIF)</li>
                        </ul>
                        <hr className="footer-divider"/>
                        <p className="footer-text">SEBI Authorized Sub-Broker for Direct Equity</p>
                        <hr className="footer-divider"/>
                        <Link to={"/amc-registrations"} onClick={scrollToTop} >
                            <p style={{color: '#fffc'}}> AMC Registrations </p>
                        </Link>

                    </div>
                    {isXSView &&  <hr className="footer-mobile-divider"/>}

                    {/* Sub-broker Details */}
                    <div className="footercard">
                        <p className="fot_bold">SUB-BROKER DETAILS</p>
                        <hr className="footer-divider"/>
                        <p className="footer-col-label">REGISTERED SUB-BROKER</p>
                        <p className="footer-text">Angel One Limited</p>
                        <p className="footer-col-label">AP Tag: <span className="footer-text">SSSC</span> </p>
                        <hr className="footer-divider"/>
                        <p className="footer-col-label">NSE REG. NO.</p>
                        <p className="footer-text">CM-AP039781013</p>
                        <p className="footer-col-label">BSE REG. NO.</p>
                        <p className="footer-text">AP0106120113933</p>
                    </div>
                    {isXSView &&  <hr className="footer-mobile-divider"/>}

                    {/* Corporate & Tax */}
                    <div className="footercard">
                        <p className="fot_bold">CORPORATE &amp; TAX</p>
                        <hr className="footer-divider"/>
                        <p className="footer-col-label">LEGAL NAME</p>
                        <p className="footer-text" style={{lineHeight: 1.65}}>
                            Simplicity Investing India Private Limited
                        </p>
                        <p className="footer-col-label">GSTIN</p>
                        <p className="footer-text">27AAQCS0218M1ZZ</p>
                        <p className="footer-col-label">CIN</p>
                        <p className="footer-text" style={{wordBreak: "break-all"}}>U74140PN2011PTC139962</p>
                    </div>

                    {isXSView &&  <hr className="footer-mobile-divider"/>}

                    {/* Registered Office */}
                    <div className="footercard">
                        <p className="fot_bold">REGISTERED OFFICE</p>
                        <hr className="footer-divider"/>
                        <a
                            href="https://www.google.com/maps?q=6, Bhosale Heights, 1195 FC Road, Pune 411005 Maharashtra."
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer-text"
                        >
                            <address className="footer-mono-val ps-2">
                                Bhosale Heights,<br/>
                                H. No. 1195/5,<br/>
                                Fergusson College Road,<br/>
                                Shivajinagar,<br/>
                                Pune, Maharashtra – 411005<br/>
                                India
                            </address>
                        </a>
                    </div>

                </div>
            </div>

            {/* Disclaimer */}
            <div className="footer-disc-bar">
                <div className="footer-disc-icon">
                    <img src={footerIcon}
                         height={16}
                         className=""/>
                </div>
                <p className="footer-col-label p-0 m-0">
                    <strong className="footer-mono-val">Disclaimer:</strong>{" "}
                    Mutual Fund investments are subject to market risks. Read all scheme related documents carefully.
                    The securities quoted are exemplary and are not recommendatory. Investments in the securities market
                    are subject to market risks; read all related documents carefully before investing. Past performance
                    is not indicative of future results. The information provided is for general informational purposes
                    only and should not be considered as financial advice.
                </p>
            </div>

            {/* Bottom bar */}
            <div className="footer-bottom-bar">
                {isMobileView ? <div className="cop_text">
                    <p>© 2026 Simplicity Investing India Private Limited.</p>
                    <p>All rights reserved.</p>
                </div> :
                    <div className="cop_text">
                        <p>© 2026 Simplicity Investing India Private Limited. All rights reserved.</p>
                    </div>}
                <div className="footer-legal-links">
                    <Link to={"/privacy-policy"} onClick={scrollToTop}>
                        <p className="footer-legal-link footer-text"> Privacy Policy </p>
                    </Link>
                    <Link to={"/terms-and-conditions"} onClick={scrollToTop}>
                        <p className="footer-legal-link footer-text"> Terms &amp; Conditions </p>
                    </Link>
                </div>
            </div>
        </footer>
    );
}

FooterView.propTypes = {};

export default FooterView;